import React from "react";

/**
 * Breadcrumbs + back button — the build-plan §1.6 navigation law:
 *   • every earlier crumb segment is a door (tappable), the last is "here"
 *   • back buttons NAME their destination ("← Walla Walla — May 14"),
 *     never a bare "← back".
 *
 * Crumbs `trail` = [{ label, screen?, patch? }, …]; a segment with a `screen`
 * navigates there, the final segment (no screen) renders as the current place.
 */
export function Crumbs({ trail, go }) {
  return (
    <div className="crumbs">
      {trail.map((seg, i) => {
        const last = i === trail.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && <span className="sep">›</span>}
            {seg.screen && !last ? (
              <button type="button" className="crumb" onClick={() => go(seg.screen, seg.patch || {})}>
                {seg.label}
              </button>
            ) : (
              <span className="here">{seg.label}</span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export function Back({ label, onClick }) {
  return (
    <button type="button" className="back" onClick={onClick}>← {label}</button>
  );
}
